/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type CreateBrandMutationInput = {
    name: string;
    companyId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type CreateBrandMutationVariables = {
    input: CreateBrandMutationInput;
};
export type CreateBrandMutationResponse = {
    readonly createBrand: {
        readonly brand: {
            readonly id: string;
            readonly name: string;
        } | null;
    } | null;
};
export type CreateBrandMutation = {
    readonly response: CreateBrandMutationResponse;
    readonly variables: CreateBrandMutationVariables;
};



/*
mutation CreateBrandMutation(
  $input: CreateBrandMutationInput!
) {
  createBrand(input: $input) {
    brand {
      id
      name
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateBrandMutationPayload",
    "kind": "LinkedField",
    "name": "createBrand",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BrandNode",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateBrandMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateBrandMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "23c27d55903265f50ab3edd17808944b",
    "id": null,
    "metadata": {},
    "name": "CreateBrandMutation",
    "operationKind": "mutation",
    "text": "mutation CreateBrandMutation(\n  $input: CreateBrandMutationInput!\n) {\n  createBrand(input: $input) {\n    brand {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f809a9932ce46977ccdb266990182fb7';
export default node;
